import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { MortgageRateBand } from "web_myplann/Inspiration/OwnHome/Types/MortgageRateBand";
import type { OwnHomeGoalPreset } from "web_myplann/Inspiration/OwnHome/Types/OwnHomeTypes";
import type {
	InspirationGoalRecap,
	InspirationGoalRecapRow,
} from "web_myplann/Inspiration/Types/InspirationTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";
import { formatRate } from "web_myplann/Shared/Utils/percentageFormatters";

const R = Resources.Inspiration.OwnHome.Result.createGoalSheet;

export const useOwnHomeGoalRecap = (
	preset: OwnHomeGoalPreset | null,
	rates: MortgageRateBand | undefined,
): InspirationGoalRecap | undefined => {
	const { t } = useResource();

	if (!preset || !rates) return undefined;

	const money = (value: number) => formatInspirationMoney(value);

	const savingsRow: InspirationGoalRecapRow[] =
		preset.ownFunds > 0
			? [
					{
						label: t(R.savingsLabel),
						note: t(R.savingsNote),
						value: money(preset.ownFunds),
					},
				]
			: [];

	return {
		title: t(R.title),
		description: t(R.description),
		footnote: t(R.footnote),
		continueLabel: t(R.continue),
		rows: [
			{
				label: t(R.priceLabel),
				note: t(R.priceNote, { rate: formatRate(rates.best) }),
				value: money(preset.totalValue),
			},
			{
				label: t(R.loanLabel),
				note: t(R.loanNote),
				value: money(preset.loanAmount),
			},
			...savingsRow,
			{
				label: t(R.targetLabel),
				note: t(R.targetNote),
				value: money(preset.savingsTarget),
				highlight: true,
				dividerBefore: true,
			},
		],
	};
};
